<template>
  <VerificationCodeForm />
</template>

<script setup>
import { onMounted } from "vue";
import { useRouter, onBeforeRouteLeave } from "vue-router";
import { useTitle } from "@vueuse/core";
import VerificationCodeForm from "@/components/forms/VerificationCodeForm.vue";
import useThirdPartyScripts from "@/composables/api/useThirdPartyScripts";
import { useGlobalStore } from "@/stores/globalStore";
import { useIdentityQueueStore } from "@/stores/identityQueueStore";

const { useSiftScript } = useThirdPartyScripts();
const globalStore = useGlobalStore();
const identityQueueStore = useIdentityQueueStore();
const router = useRouter();

const handleRedirect = async () => {
  await identityQueueStore.fetchIdentityDocuments();
  router.push(identityQueueStore.getNextIdentityRoute);
};

onMounted(() => {
  const msisdnRequired =
    globalStore.getMerchantSettings?.msisdnRequired === true;
  const skipVerificationCode = globalStore.getMerchantSettings?.VALIDATE_MSISDN === false && globalStore.getMerchantSettings?.VALIDATE_EMAIL === false
  if (!msisdnRequired || skipVerificationCode) {
    handleRedirect();
  }
});

useTitle("Banxa - Enter your code");
onBeforeRouteLeave(() => useSiftScript()); // grabs the userID for Sift
</script>
